import { Box } from '@mui/material';
import { ABOVE_TILE_CORNER_BOTTOM } from '~/viewportGrid/chrome';
import RegistrationShortcutHints from './RegistrationShortcutHints';
import type { Environment } from '~/engine/data/Environment';
import { FusedImageDisplay } from '~/engine/view/layers/fusedImageDisplay';
import { RenderAdapter } from '~/viewportGrid/adapters/types';
import { usePlaneViewHostedBy } from '../usePlaneViewHostedBy';

interface TileRegistrationHintMountProps {
    renderer: RenderAdapter;
    /**
     * The Environment the registration tool moves the image of, while it
     * can; undefined hides the hint.
     */
    hintHost: Environment | undefined;
}

/**
 * Mounts the registration key hint over one grid tile, at its bottom left,
 * on every tile of the Environment the registration tool acts on that
 * draws the blend, and on no other, so the keys are named only where they
 * move the image. The hint
 * decides when it shows; this mount owns nothing but the gate and the
 * place. Renders nothing for non-engine renderers (the mock adapters).
 */
export default function TileRegistrationHintMount({
    renderer,
    hintHost,
}: TileRegistrationHintMountProps) {
    const view = usePlaneViewHostedBy(renderer, hintHost);
    if (!view || view.fusedImageDisplay !== FusedImageDisplay.Blended) {
        return null;
    }
    return (
        <Box
            sx={{
                position: 'absolute',
                left: 6,
                bottom: ABOVE_TILE_CORNER_BOTTOM,
                pointerEvents: 'none',
            }}
        >
            <RegistrationShortcutHints />
        </Box>
    );
}
